import {
  type EmailVisiblePlainCutMode,
  computeEmailVisiblePlainCut,
} from "@v1/backend/logic/channel_routing/email_visible_plain_cut";
import { normalizeEmailPlainLineBreaks } from "@v1/backend/logic/channel_routing/inbound_email_html_to_plain";

const MIN_HIDDEN_LENGTH: number = 20;

export type HeroEmailSplit = {
  readonly visible: string;
  readonly hidden: string | null;
  readonly canToggle: boolean;
};

export function splitHeroEmailBody(
  fullPlain: string,
  direction: "inbound" | "outbound",
): HeroEmailSplit {
  const mode: EmailVisiblePlainCutMode =
    direction === "outbound" ? "ui" : "inbound";
  const plain: string = normalizeEmailPlainLineBreaks(fullPlain.trimEnd());
  if (plain.length === 0) {
    return { visible: "", hidden: null, canToggle: false };
  }

  const cutIndex: number | null = computeEmailVisiblePlainCut(fullPlain, mode);
  if (cutIndex === null || cutIndex <= 0) {
    return { visible: plain.trim(), hidden: null, canToggle: false };
  }

  const visible: string = plain.slice(0, cutIndex).trimEnd();
  const hidden: string = plain.slice(cutIndex).trimStart();
  if (visible.length === 0) {
    return { visible: plain.trim(), hidden: null, canToggle: false };
  }

  return {
    visible,
    hidden: hidden.length > 0 ? hidden : null,
    canToggle: hidden.length >= MIN_HIDDEN_LENGTH,
  };
}

/** Portal / plain messages — no quote trim. */
export function splitHeroPortalBody(fullPlain: string): HeroEmailSplit {
  const text: string = fullPlain.trim();
  return { visible: text, hidden: null, canToggle: false };
}
